module.exports = __webpack_public_path__ + "static/media/coin50.d921284c.png";